<template>
  <div class="box">
    <article class="media">
      <div class="media-content">
        <div :id="chartId" :style="`width:${width}; height:322px;`" class="has-text-centered"></div>
        <div class="has-text-centered">
          <h5>
            <b>{{ this.title }}</b>
          </h5>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
/* eslint-disable indent */
export default {
  props: {
    labels: { type: Array, default: () => [] },
    data: { type: Array, required: true },
    title: { type: String },
    name: { type: String, default: 'default' },
    horizantal: { type: Boolean, default: false },
    width: { type: String, default: '90%' },
    labelRotate: { type: Number }
  },
  data () {
    return {
      chartElement: null
    }
  },
  computed: {
    chartId () {
      return `bar-chart-${this.name}`
    }
  },
  mounted () {
    this.chartElement = window.echarts.init(document.getElementById(this.chartId))
    this.loadChartData(this.data)
    this._resizeHandler = () => {
      this.chartElement.resize()
    }
    window.addEventListener('resize', this._resizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this._resizeHandler)
  },
  methods: {
    loadChartData (data) {
      const chartData = data.map(d => (d !== null ? parseFloat(d.toFixed(2)) : null))
      const options = {
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        series: [
          {
            type: 'bar',
            stack: 'stack1',
            data: chartData.map(c => {
              return c !== null
                ? {
                    value: c,
                    itemStyle: { color: '#3ec154' },
                    label: { show: c !== 0 }
                  }
                : {
                    value: 4,
                    itemStyle: { color: '#DCDCDC' }
                  }
            })
          },
          {
            type: 'bar',
            stack: 'stack1',
            data: chartData.map(c => {
              return c !== null
                ? {
                    value: 4 - c,
                    itemStyle: { color: '#dd2248' },
                    label: { show: false }
                  }
                : {
                    value: 4,
                    itemStyle: { color: '#DCDCDC' }
                  }
            })
          }
        ]
      }

      const labelData = [{ type: 'category', data: [...this.labels] }]
      const valueData = [{ type: 'value', min: 0, max: 4 }]
      if (!this.horizantal) {
        if (this.labelRotate) {
          labelData[0].axisLabel = { rotate: this.labelRotate }
        }
        options.xAxis = labelData
        options.yAxis = valueData
      } else {
        options.xAxis = valueData
        options.yAxis = labelData
      }

      this.chartElement.setOption(options)
      setTimeout(() => {
        this.chartElement.resize()
      }, 100)
    },
    resize () {
      window.dispatchEvent(new Event('resize'))
    }
  },
  watch: {
    data (newData) {
      if (newData && this.chartElement) {
        this.loadChartData(newData)
      }
    }
  }
}
</script>
